import type { BarcodeProps } from 'react-barcode';

export type BarcodeFormat = NonNullable<BarcodeProps['format']>;

const BARCODE_FORMAT_ALIASES: Record<string, BarcodeFormat> = {
  CODE39: 'CODE39',
  CODE128: 'CODE128',
  CODE128A: 'CODE128A',
  CODE128B: 'CODE128B',
  CODE128C: 'CODE128C',
  EAN13: 'EAN13',
  EAN8: 'EAN8',
  EAN5: 'EAN5',
  EAN2: 'EAN2',
  UPC: 'UPC',
  UPCA: 'UPC',
  UPCE: 'UPCE',
  ITF14: 'ITF14',
  ITF: 'ITF',
  MSI: 'MSI',
  MSI10: 'MSI10',
  MSI11: 'MSI11',
  MSI1010: 'MSI1010',
  MSI1110: 'MSI1110',
  PHARMACODE: 'pharmacode',
  CODABAR: 'codabar',
  GENERICBARCODE: 'GenericBarcode',
};

export const translateBarcodeFormat = (format?: string | null): BarcodeFormat | undefined => {
  const trimmed = format?.trim();
  if (!trimmed) return undefined;

  const normalized = trimmed.replace(/[\s_-]+/g, '').toUpperCase();
  return BARCODE_FORMAT_ALIASES[normalized];
};
